import styled from '@emotion/styled/macro';
import { H2 } from '../../../common/Headings/Headings.styles';
import Button from '../../../components/Button/Button';
import rem from '../../../utils/rem/rem';
import { HorizontalLine } from '../../StoreControl/StoreRecord.styles';

export const RecipeForm = styled.div`
  margin: 0 32px;
  position: relative;
`;

export const SaveButton = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
`;

export const H2WithMargin = styled(H2)`
  margin-bottom: ${rem(16)};
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${rem(16)} 24px;
  margin-bottom: ${rem(16)};
`;

export const HR = styled(HorizontalLine)`
  margin-top: ${rem(40)};
  padding-bottom: ${rem(36)};
`;
